export function decodeBase64Json<T>(raw: string | null | undefined): T | null {
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(atob(raw)) as T;
  } catch {
    return null;
  }
}
